import { Box, Button, Chip, Grid, Typography } from '@mui/material';
import { useContext } from 'react';
import { Context } from '../../../../App';
import { formatCurrency } from '../../../../utility/helpers/displayHelper';

// Styles extracted for cleaner code
const styles = {
    container: (isOpenSideBar) => ({
        position: 'relative',
        background: '#fff',
        // bottom: 0,
        // left: isOpenSideBar ? '288px' : '65px',
        // transition: 'width 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms',
        // right: 0,
        Width: '100%',
        borderTop: '1px solid #e0e0e0',
        padding: '24px 32px 24px 24px',
        zIndex: 99,
        boxShadow: '0 -6px 24px 0 rgba(0, 0, 0, 0.12)',
    }),
    invoiceWrapper: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
    },
    invoiceChip: {
        backgroundColor: '#006CDD',
        color: 'white',
        minWidth: '24px',
        height: '24px',
        fontSize: '16px',
        fontWeight: 600,
        '& .MuiChip-label': { padding: '0!important' },
    },
    invoiceText: {
        color: 'rgba(0, 0, 0, 0.87)',
        fontWeight: 600,
        fontSize: '16px',
    },
    rightWrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: '16px',
    },
    paymentWrapper: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
    },
    paymentText: {
        color: 'rgba(0, 0, 0, 0.87)',
        fontSize: '16px',
        fontWeight: 600,
    },
    paymentChip: {
        backgroundColor: '#006CDD',
        color: 'white',
        height: '32px',
        fontSize: '16px',
        fontWeight: 600,
        minWidth: '80px',
    },
    buttonGroup: {
        display: 'flex',
        gap: '12px',
    },
};

const RecordPaymentStickyBottom = ({
    onlyOneCustomerSelected,
    recordPaymentParams,
    selectedRows,
    getTotalAdditionalPayment,
    onDiscardChanges,
    onSave,
    onSingleExport,
}) => {
    const { isOpenSideBar } = useContext(Context);

    return (
        <Box sx={styles.container(isOpenSideBar)}>
            <Grid container alignItems="center">
                {/* Left Side - Invoice count */}
                <Grid item xs={12} md={12} lg={isOpenSideBar ? 2 : 4} xl={5}>
                    <Box sx={styles.invoiceWrapper}>
                        <Chip label={selectedRows?.length || 0} sx={styles.invoiceChip} />
                        <Typography variant="body1" sx={styles.invoiceText}>
                            Invoices
                        </Typography>
                    </Box>
                </Grid>

                {/* Right Side - Payment & Actions */}
                <Grid item xs={12} md={12} lg={isOpenSideBar ? 10 : 8} xl={7}>
                    <Box sx={styles.rightWrapper}>
                        {/* Payment recorded */}
                        <Box sx={styles.paymentWrapper}>
                            <Typography variant="body1" sx={styles.paymentText}>
                                Payment Recorded
                            </Typography>
                            <Chip label={`${formatCurrency(getTotalAdditionalPayment())}`} sx={styles.paymentChip} />
                        </Box>

                        {/* Action Buttons */}
                        <Box sx={styles.buttonGroup}>
                            <Button color="primary" variant="outlined" onClick={onDiscardChanges}>
                                DISCARD CHANGES
                            </Button>
                            <Button
                                color="primary"
                                variant="contained"
                                onClick={() => {
                                    if (onlyOneCustomerSelected) onSingleExport();
                                    else onSave(true);
                                }}
                            >
                                {!onlyOneCustomerSelected
                                    ? 'Record and Export'
                                    : recordPaymentParams?.status?.length === 1 && recordPaymentParams.status[0] === 'fullyPaid'
                                    ? 'Record and Export'
                                    : 'Record and Export'}
                            </Button>
                            <Button
                                color="secondary"
                                variant="contained"
                                onClick={() => {
                                    onSave(false);
                                }}
                            >
                                Record
                            </Button>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default RecordPaymentStickyBottom;
